<template>
  <div class="overlay">
    <content-card :width="width">
      <template #header>
        <div class="subtitle">
          {{ t("restart_modal.title") }}
        </div>
      </template>
      <template #description>
        <div class="d-flex flex-column align-items-center g-24">
          <button class="continue-button" @click="$emit('confirmRestart')">
            {{ t("restart_modal.yes") }}
          </button>
          <button class="continue-button-clear" @click="$emit('closeRestart')">
            {{ t("restart_modal.no") }}
          </button>
        </div>
      </template>
    </content-card>
  </div>
</template>

<script>
import { useI18n } from "vue-i18n";
export default {
  setup() {
    const { t } = useI18n();
    return {
      t,
    };
  },
  emits: ["restart", "closeRestart", "confirmRestart"],
  data() {
    return {
      width: 80
    }
  },
  mounted() {
    this.changeWidth();
    this.$nextTick(() => {
      window.addEventListener("resize", this.changeWidth);
    });
  },
  methods: {
    changeWidth() {
      if (window.innerWidth < 768) {
        this.width = 100;
      } else {
        this.width = 80;
      }
    }
  }
};
</script>

<style scoped>
.overlay {
  background-color: rgba(0, 0, 0, 0.7);
  position: absolute;
  height: 100%;
  width: 100%;
  top: 0;
}
</style>
